import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useGetStrings } from "@app/store/service/cmsService"
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons/faAngleLeft"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, ButtonStyle, classNamez, Variant } from "@tecreation/funnel-components"
import "./ContentHeader.css"

/**
 *
 * @param {{children,colorStyle: "white" | "color", canGoBack, animation, className, customReturnFunction, ariaLabel }} param0
 * @returns
 */
const ContentHeader = ({ children, colorStyle, canGoBack, animation, className, customReturnFunction }) => {
	const { pop } = useCustomNavigation()
	const {
		data: { buttonLabelGoBack, bookingHeaderLabel },
	} = useGetStrings(undefined, { defaultData: {} })

	return (
		<div
			className={
				"contentHeader flex flex-center p-3 px-7 px-lg-10 py-lg-6 f-second " +
				className +
				classNamez({
					"color-fg-white": colorStyle === "color",
					"color-fg-primary": colorStyle === "white",
					"color-bg-default": colorStyle === "white",
				})
			}
		>
			{canGoBack && (
				<div className="contentHeader__backBtn color-fg-white f0 pl-2 pl-lg-7">
					<Button
						style={ButtonStyle.icon}
						ariaLabel={buttonLabelGoBack}
						onClick={() => {
							customReturnFunction && customReturnFunction(animation)
							!customReturnFunction && pop(-1, animation)
						}}
						variant={colorStyle === "white" ? Variant.primary : Variant.white}
					>
						<FontAwesomeIcon icon={faAngleLeft} />
					</Button>
				</div>
			)}
			<div className="cotainer-sm text-center f-second" role="region" aria-label={bookingHeaderLabel}>
				<h1 className="f3 f-lg-1 regular color-fg-primary block">{children}</h1>
			</div>
		</div>
	)
}

export { ContentHeader }
